import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=5ff4382e&scoped=true&lang=pug&"
import script from "./Onboarding.vue?vue&type=script&lang=js&"
export * from "./Onboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff4382e",
  null
  
)

export default component.exports